export default {"src":"/_next/static/media/birthday.68a869d1.svg","height":42,"width":42};